import { makeSceneDoc } from '../kit.js';

/**
 * 主街：城里最体面的一段。
 * 杂货铺、书局、汤池都在这儿，早上还会有流动早市——净水巷原本属于此处。
 */
export const mainStreetDoc = makeSceneDoc({
  id: 'main_street',
  name: '主街',
  region: 'city',
  tier: 2,
  node: 'main_street',
  desc: '街砖铺得整齐，两边字号一家挨一家。',
  w: 48, h: 28,
  fill: '=',
  spawn: { gx: 24, gy: 2 },
  draw(b, rng) {
    b.rect(0, 0, 48, 28, '=');
    b.rect(0, 0, 48, 3, ',');
    b.rect(0, 25, 48, 3, ',');
    // 沿街的铺面：木地板只铺房子坐的那几格，门前留一格门槛。
    // 早先铺成整片 8x6，房子只占中间 3x2，人能绕到屋后头、站上房顶，
    // 看着就成了「门口跟房子对不上」。没开门的脸面留作门前空场。
    b.rect(2, 3, 8, 6, 'o');
    b.rect(5, 6, 3, 2, '.');      b.set(6, 8, '+');    // 杂货铺
    b.rect(14, 3, 8, 6, 'o');
    b.rect(17, 6, 3, 2, '.');     b.set(18, 8, '+');   // 书局
    b.rect(26, 3, 8, 6, 'o');
    b.rect(29, 6, 3, 2, '.');     b.set(30, 8, '+');   // 汤池
    b.rect(38, 3, 8, 6, 'o');
    b.rect(2, 19, 8, 6, 'o');
    b.rect(14, 19, 8, 6, 'o');
    b.rect(26, 19, 8, 6, 'o');
    b.rect(38, 19, 8, 6, 'o');
    b.rect(10, 12, 28, 4, 'o');                        // 街心小广场
  },
  props: [
    { type: 'bank_exchange', gx: 9, gy: 7 },
    { type: 'public_bath_sign', gx: 33, gy: 7 },
    { type: 'laundry_vat', gx: 27, gy: 7 },
    { type: 'cooking_vat', gx: 42, gy: 6 },
    { type: 'fish_stall', gx: 12, gy: 13 },
    { type: 'tofu_stall', gx: 20, gy: 13 },
    { type: 'firewood_stall', gx: 28, gy: 13 },
    { type: 'basket_stall', gx: 34, gy: 13 },
    { type: 'steamed_bun_stall', gx: 16, gy: 16 },
    { type: 'rice_cake_stall', gx: 24, gy: 16 },
    { type: 'noodle_stall', gx: 32, gy: 16 },
    { type: 'stone_lantern', gx: 24, gy: 10 },
  ],
  portals: [
    { to: 'gate', gx: 24, gy: 1, spawn: [22, 22], label: '城门口' },
    { to: 'market', gx: 24, gy: 26, spawn: [24, 2], label: '市集' },
    { to: 'yamen_sq', gx: 46, gy: 14, spawn: [3, 20], label: '衙前广场' },
    { to: 'general', gx: 6, gy: 8, spawn: [6, 13], label: '杂货铺' },
    { to: 'library', gx: 18, gy: 8, spawn: [6, 13], label: '书局' },
    { to: 'onsen', gx: 30, gy: 8, spawn: [7, 13], label: '汤池' },
  ],
});

export default mainStreetDoc;
